import { IJet } from "@evennt-tech/api-v2-core";
import { useEffect } from "react";
import { shallow } from "zustand/shallow";
import { useJetStore } from "store/jet/jet.store";

type UseJetArgs = {
  showId?: string;
};

export type UseJetRes = [IJet | null, boolean];

function useJet({ showId }: UseJetArgs): UseJetRes {
  const {
    fetch: fetchJetShow,
    autoCatch: autoCatchJet,
    jet,
    isLoading,
  } = useJetStore(
    (state) => ({
      fetch: state.fetch,
      autoCatch: state.autoCatch,
      jet: state.getByShowId(showId as string),
      isLoading: state.isLoading,
    }),
    shallow
  );

  useEffect(() => {
    if (!showId) {
      return;
    }

    fetchJetShow(showId);
    autoCatchJet(showId);
  }, [showId]);

  return [jet, isLoading];
}

export default useJet;
